<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-folder-open"></i></div>
      <div>
        PJ pour dossier d'inscription par classe
        <div class="page-title-subheading">Gestion des PJ</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
<div class="container">
    <div class="d-flex justify-content-end">
        <div class="form-group ms-auto">
                        <label for=""> <strong>Rechercher:</strong> </label>
                        <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
                    </div>
    </div>
    <div class="row">
        <div class="col-12 col-md-4 mb-3" *ngFor="let d of data | sampleSearch:search_text:'inscription_files'">
            <div class="card card-body">
                <h5 class="text-center fw-bold">Classe</h5>
                <h6 class="text-center mb-3 ">{{d?.name}}</h6>
                <h5 class="text-center mb-3 fw-bold">Documents attendus</h5>
                <table class="table table-sm">
                    <tbody>
                        <tr class="" *ngFor="let f of d.files">
                            <td><i class="fa fa-paperclip text-primary" aria-hidden="true"></i></td> 
                            <td><span>{{f.document?.name}}</span></td>
                            <td>
                                <i *ngIf="f.is_active" (click)="setStatus(f.id,0)"  class="fa-solid fa-lock text-danger" style="cursor: pointer;"></i>
                                <i *ngIf="!f.is_active" (click)="setStatus(f.id,1)"  class="fa-solid fa-unlock text-success" style="cursor: pointer;"></i>         
                            </td>
                        </tr>
                    </tbody>
                </table>
                   
            </div>
        </div>
    </div>
    <pagination-controls 
    [maxSize]="9"
    [directionLinks]="true"
    [autoHide]="true"
    [responsive]="true"
    [previousLabel]="'Previous'"
    [nextLabel]="'Next'"
    [screenReaderPaginationLabel]="'Pagination'"
    [screenReaderPageLabel]="'page'"
    [screenReaderCurrentLabel]="'You\'re on page'">
    </pagination-controls>
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Associer un document pour inscription à une classe</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class="form-group col-12 mb-3">
                <label for="">Choisir la classe <span class="text-danger ml-2">(*)</span></label>
                <select name="classroom_id" id="" class="form-control" ngModel>
                    <option selected disabled></option>
                    <option *ngFor="let c of classrooms" [value]="c.id">{{c.name}}</option>
                </select>
            </div>
            <ul>
                <li *ngFor="let d of documentsTreated; let i=index">
                    <div class="form-check mb-2 d-flex">
                        <label class="mr-1" for="flexRadioDefault{{i}}">{{d.name}}</label>
                        <input  class="form-check-input" type="checkbox" [checked]="d.status" name="d.status" [(ngModel)]="d.status" (change)="d.status!=d.status" id="flexRadioDefault{{i}}">
                    </div>
                </li>
            </ul>
         
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

